import { Pipe, PipeTransform } from '@angular/core';
import { eUnit } from '@app/modules/shipper/enums/shipper-enum';

@Pipe({
    name: 'WeightKgToLbs'
})
export class WeightKgToLbs implements PipeTransform {
    transform(weight: number | string, unit: eUnit): string {
        if (weight === null || weight === undefined) {
        return '0.00 lbs.';
        }

        const numericWeight = Number(weight);
        if (Number.isNaN(numericWeight)) {
            return '0.00 lbs.';
        }

        let convertedWeight: number;

        if (unit === eUnit.KG) {
            convertedWeight = numericWeight * 2.205;
        } else {
            convertedWeight = numericWeight;
        }
        return `${convertedWeight.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
        })} lbs.`;
    }
}